import { Accordion, AccordionDetails, AccordionSummary, TextField, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { NodeImageUploader } from './nodeImageUploader';

export const ElementPropertyNodeImage = (props) => {

    return (
        <Accordion >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
            >
                <Typography>Image</Typography>
            </AccordionSummary>
            <AccordionDetails>
                
                <TextField
                    id="image"
                    name="image"
                    label="Image URL"
                    value={(props.imageUrl ?? props.node?.data?.image) || ""}
                    onChange={(e) => props.updateImageUrl && props.updateImageUrl(e)}
                    fullWidth
                    size="small"
                    margin="dense"
                    InputProps={{
                        readOnly: false,
                    }}
                />
                <Typography variant="caption" align='center' color="textSecondary" sx={{ mb: 1, display: 'block' }}>
                    You can paste a node image URL above, or upload a picture below.
                </Typography>
                <NodeImageUploader node={props.node} projectId={props.projectId} updateImage={props.updateImage}/>
            </AccordionDetails>
        </Accordion>
    );
};